/* global tinymce */

const IS_URL_REGEX =
  /(?![^" ]*(?:jpg|png|gif|svg))(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$])/gim;

function replaceLinks(textToReplace, link) {
  // Match all links starting with HTTPS || HTTP || WWW || FTP || FILE
  return textToReplace
    .replace(/&amp;/gi, "&") // Needed for replacing amp flags in URLs generated by external editors
    .replace(IS_URL_REGEX, () => {
      return link;
    });
}

const urlReplacerDialogConfig = {
  title: "URL Replacer",
  body: {
    type: "panel",
    items: [
      {
        type: "input",
        name: "urlToReplaceWith",
        label: "URL",
      },
    ],
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Replace URLs",
      primary: true,
    },
  ],
  initialData: {
    urlToReplaceWith: "",
  },
  onSubmit: function (api) {
    if (IS_URL_REGEX.test(api.getData().urlToReplaceWith)) {
      tinymce.activeEditor.execCommand(
        "mceSetContent",
        false,
        replaceLinks(tinymce.activeEditor.getContent(), api.getData().urlToReplaceWith),
      );
      api.close();
    } else {
      tinymce.activeEditor.windowManager.alert(
        "URL Is Incorrect: </br>- URL should start with either `https://` or `www.`",
      );
    }
  },
};

export { urlReplacerDialogConfig };
